export default function Textarea(props) {
	const {
		id,
		name,
		className,
		style,
		label,
		showLabel,
		placeholder,
		value,
		essential,
		readOnly,
		disabled,
		children,
		onChange = () => {},
	} = props;

	return (
		<div className={className ? `gs-input ${className}` : 'gs-input'} style={style}>
			{label && (
				<label
					id={label ? `${id}-label` : null}
					htmlFor={id}
					className={`${essential ? 'gs-essential' : ''} ${showLabel ? '' : 'sr-only'}`}
				>
					{label}
				</label>
			)}
			<textarea
				id={id}
				name={name}
				placeholder={placeholder}
				aria-labelledby={label ? `${id}-label` : null}
				value={value}
				readOnly={readOnly}
				disabled={disabled}
				onChange={onChange}
			/>
			{children}
		</div>
	);
}